<template>
      <card>
        <list
          :columns="columns"
          :modalCreate="modalCreate"
          :removeLink="removeLink"
          :cardLink="cardLink"
          :isUpdate="true"
          :isAdd="true"
          :itemLink="itemLink"
          :setLink="setLink"
          :fields="fields"
          :searchDisable="false"
          @change="change"
          @changeFunction="changeFunction"
          v-model="val"
        />
      </card>
</template>
<script>
export default {
  name: "products",
  methods: {
    changeFunction(val) {},
    change(val) {},
  },
  data() {
    return {
      val: [],
      modalCreate: "category",
      fields: [
            {
              label: "Название",
              key: "title",
              type: "field",
              textType: "text", 
              isMultiLang:true
            },
               {
                col:' col-12',
                key: "parent",
                label: "Главная категория",
                type: "select",
                modal:'category',
                selectKey: "title",
                textType: "text",
                prefix:'category_category'
              },
        
      ],
      /** APIs */
      removeLink: "",
      cardLink: "item_category",
      itemLink: "warehouse/categories",
      setLink: "warehouse/categories",
      columns: [
        {
          key: "id",
          title: "ID",
          checkbox: false,
          control: false,
          align: "left",
          timer: false,
          detail: false,
          // sortBy:'id'
        },
        
        {
          key: "title",
          title: "Наименование",
          checkbox: false,
          control: false,
          align: "left",
          timer: false,
          detail: false,
        },
        {
          key: "is_active",
          title: "Активность",
          checkbox: false,
          control: false,
          align: "left",
          timer: false,
          detail: false,
        },
        {
          key: "parent",
          keyAs: "category",
          title: "Главная категория",
          checkbox: false,
          control: false,
          align: "left",
          timer: false,
          object: 'title',
        },
        {
          detail: true,
          remove: true,
        },
      ],
    };
  },
};
</script>
<style>
</style>
